import { CurrencyEnum } from '@systemeio/types'
import { AffiliateSumType } from 'modules/affiliate/types/affiliate-statistic-interface'

export const getMainCurrency = (total: AffiliateSumType) =>
  (Object.keys(total) as CurrencyEnum[]).reduce<CurrencyEnum | undefined>(
    (main, cur) => (main === undefined || total[cur] > total[main] ? cur : main),
    undefined,
  )
